export default "__VITE_ASSET__DFnV6FgL__"